/* unplugin-vue-components disabled */import { render } from "./SimpleVerticalBarChart.vue?vue&type=template&id=133927be&scoped=true"
import script from "./SimpleVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./SimpleVerticalBarChart.vue?vue&type=script&lang=js"

import "./SimpleVerticalBarChart.vue?vue&type=style&index=0&id=133927be&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133927be"]])

export default __exports__